import { render, staticRenderFns } from "./FormServicioManual.vue?vue&type=template&id=beb48744&"
import script from "./FormServicioManual.vue?vue&type=script&lang=js&"
export * from "./FormServicioManual.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports